import { useTypedParams } from "react-router-typesafe-routes";

import { ClientNotificationsCard } from "@components/Cards/ClientNotificationsCard/ClientNotificationsCard";

import { routes } from "@pages/routes";

type Props = {
  initialUserTablePageIndex?: number;
};

export const ClientNotifications = ({
  initialUserTablePageIndex = 0,
}: Props) => {
  const { clientId } = useTypedParams(routes.portal.clients.client);

  return (
    <ClientNotificationsCard
      clientId={clientId}
      viewMode="active"
      initialPageIndex={initialUserTablePageIndex}
    />
  );
};
